import React from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { useDispatch } from 'react-redux';
import { hooks, signaling } from '@lifesize/clients.sdk';
import { FormControlLabel, makeStyles, Switch, Theme } from '@material-ui/core';
import { openInCallModal } from 'actions/InCallModal';
import modals from 'constants/Modals';
import oldClasses from './CallDetails.module.scss';
import clsx from 'clsx';

interface Props {
  intl: { formatMessage: Function };
  outOfCall: boolean;
}

const messages = defineMessages({
  waitingRoom: { id: 'components.inCall.waitingRoom', defaultMessage: 'Waiting Room' },
  lockMeeting: { id: 'components.inCall.meetingLock.title', defaultMessage: 'Lock Meeting' }
});

const MeetingLock = (props: Props) => {
  const classes = useStyles({});
  const dispatch = useDispatch();
  const isRequestingLockUnlockMeeting = hooks.useRequestingLockUnlockMeeting();
  const isWaitingRoomEnabled = hooks.useIsWaitingRoomEnabled();
  const waitingRoomUsers = hooks.useWaitingRoomUsers() || [];

  const handleChange = () => {
    if (isWaitingRoomEnabled && waitingRoomUsers.length) {
      dispatch(openInCallModal(modals.waitingRoomWarningModal));
    } else if (isWaitingRoomEnabled) {
      signaling.disableWaitingRoom();
    } else {
      signaling.enableWaitingRoom();
    }
  };

  return (
    <div
      className={clsx({ [classes.outOfCall]: props.outOfCall }, oldClasses.meetingLockContainer)}
      data-testid={isWaitingRoomEnabled ? 'btnUnlockMeeting' : 'btnLockMeeting'}
    >
      <FormControlLabel
        classes={{ root: classes.root }}
        control={<Switch checked={isWaitingRoomEnabled} onChange={handleChange} name="meetingLock" color="primary" />}
        data-testid="meetingLock"
        disabled={isRequestingLockUnlockMeeting}
        label={props.intl.formatMessage(messages.waitingRoom)}
        labelPlacement="start"
      />
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    marginLeft: 0,
    '& span': {
      fontSize: 12,
      fontWeight: theme.typography.fontWeightBold
    }
  },
  outOfCall: {
    margin: theme.spacing(0, 3, 1, 3)
  }
}));

export default injectIntl(MeetingLock);
